import React from "react";
import clsx from "clsx";
import styles from "./LoadingSpinner.module.css";

type SpinnerSize = "small" | "extraSmall";

type SpinnerProps = {
  size?: SpinnerSize;
  className?: string;
  /** @default "Laddar" */
  label?: string;
  /** Hide from accessibility tree when a parent already exposes busy/status. */
  silent?: boolean;
};

const Spinner: React.FC<SpinnerProps> = ({
  size,
  className,
  label = "Laddar",
  silent = false,
}) => {
  const rootClass = clsx(styles.root, className, {
    [styles.rootSmall]: size === "small",
    [styles.rootExtraSmall]: size === "extraSmall",
  });

  return (
    <div
      className={rootClass}
      role={silent ? undefined : "status"}
      aria-label={silent ? undefined : label}
      aria-hidden={silent ? true : undefined}
    />
  );
};

export default Spinner;
